/*
 * @Description: 没有tab带头图大于4张卡片的样式,
 * @Author: ywj
 * @Date: 2025-02-07 11:04:44
 * @LastEditTime: 2025-04-08 11:30:33
 * @LastEditors: ywj@originqc.com
 */
import React, { useState,useEffect } from 'react'
import CustomTitle from '@/components/custom-title';
import GoMore from '@/components/more';
import Card from '@/components/card'

import './index.scss';

interface IGoods {
  // title: string,
  isTab: string,//more显示更多，tab,tab切换标签1，标签2
  goodsData: any,
  data: any,

}

const HeadGoods: React.FC<IGoods> = (props) => {
  // const [tabId, setTabId] = useState<number>(props.goodsData![0]?.id);
  const {goodsData, data } = props;
  const [serviceText, setServiceText] = useState<string[]>(['']);
  useEffect(() => { 
    if (data?.serviceIds) { 
      const linkStringArr = JSON.parse(data?.serviceIds);
      return setServiceText(linkStringArr)
    }
  },[data])
  const changeMarginTop = () => { 
    switch (data?.name) { 
      case '量子芯片及工艺设备':
        return '85px';
      case '稀释制冷机及配套产品':
        return '10px';
      case '量子计算测控仪器及配套产品':
        return '30px';
    }
  }

  return (
    <>
      <div className="head-goods-top">
        <CustomTitle title={data?.name} /> <GoMore data={ data} /> 
      </div>
      <div className="head-goods-box">
        <div className="head-goods-left">
          <p className='head-goods-title'>{data?.mainProductName}</p>
          <div className='head-goods-service-text'>{serviceText.map(item => { 
            return <p className='head-goods-subtitle' key={item}>{item}</p>
          })}</div>
          <img src={data?.pic} alt="bg" style={{marginTop:changeMarginTop()}} />
        </div>
        <div className="head-goods-right">
        {(goodsData?.length>8?goodsData?.slice(0,8):goodsData)?.map((item:any) => {
        return (              
          <React.Fragment key={item.id}>
              <Card {...item} width={234}  is_list="home"/>
          </React.Fragment>
          
        ) 
      })}
        </div>

      </div>
    </>
  )
}

export default HeadGoods;